import bundlingMarkdown from '@/new/content/announcements/bundling-2026-05.md?raw';
import issuesUpgradeMarkdown from '@/new/content/announcements/issues-upgrades-2026-04.md?raw';
import kimFilesMarkdown from '@/new/content/announcements/kim-files-2026-05.md?raw';
import kimTemplatesMarkdown from '@/new/content/announcements/kim-templates-2026-05.md?raw';
import matterContextMarkdown from '@/new/content/announcements/matter-context-2026-04.md?raw';

export interface Announcement {
  /** Unique identifier - used for localStorage tracking */
  id: string;
  /** Short heading shown in the sidebar widget */
  heading: string;
  /** Brief text shown below the heading in the sidebar */
  preview: string;
  /** Optional heading override shown in the modal */
  modalHeading?: string;
  /** Markdown rendered as the modal body */
  modalMarkdown?: string;
  /** Small image shown in the sidebar card */
  sidebarImage?: string;
  /** Larger image shown above the markdown in the modal */
  dialogImage?: string;
  /** Link to navigate to when clicking "Learn more" in the modal */
  learnMoreHref?: string;
  /** Whether this announcement comes from release notes */
  isReleaseNote?: boolean;
}

/**
 * Define announcements here. The first item is treated as the "current" announcement.
 * When a user dismisses it, it won't show again (tracked by id in localStorage).
 */
export const announcements: Announcement[] = [
  {
    id: 'kim-files-2026-05',
    heading: 'Attach files in Kim',
    preview: 'Upload ad-hoc PDFs, DOC files, and DOCX files to Kim threads.',
    modalMarkdown: kimFilesMarkdown,
    sidebarImage: 'kim-files.png',
    dialogImage: 'kim-files.png',
    learnMoreHref: '/release-notes',
  },
  {
    id: 'bundling-2026-05',
    heading: 'New: Document Bundles',
    preview: 'Export documents as indexed and paginated court-ready PDFs.',
    modalMarkdown: bundlingMarkdown,
    sidebarImage: 'bundling.png',
    dialogImage: 'bundling.png',
    learnMoreHref: '/release-notes',
    isReleaseNote: true,
  },
  {
    id: 'kim-templates-2026-05',
    heading: 'Kim Templates',
    preview: 'Turn repeatable legal workflows into reusable prompts.',
    modalMarkdown: kimTemplatesMarkdown,
    sidebarImage: 'custom-templates.png',
    dialogImage: 'custom-templates.png',
  },
  {
    id: 'matter-context-2026-04',
    heading: 'Better Matter Context',
    preview: `It's now easier to get your issues, parties, and other data into Wexler.`,
    modalHeading: 'Introducing Matter Context',
    modalMarkdown: matterContextMarkdown,
    sidebarImage: 'matter-context-highlight.png',
    dialogImage: 'matter-context-highlight.png',
    learnMoreHref: '/release-notes',
  },
  {
    id: 'issues-upgrades-2026-04',
    heading: 'Matter Issue Changes',
    preview: 'Issues are moving from free-form text to discrete labels.',
    modalHeading: 'Upgrading Matter Issues',
    modalMarkdown: issuesUpgradeMarkdown,
    sidebarImage: 'matter-issues-announcement.png',
    dialogImage: 'matter-issues-announcement.png',
  },
];

/**
 * Returns the latest announcement that the user hasn't dismissed yet.
 */
export function getLatestAnnouncement(dismissedIds: string[]): Announcement | null {
  return announcements.find((a) => !dismissedIds.includes(a.id)) ?? null;
}
